import React from 'react'
import colors from '../../theme/colors'
import boxShadow from '../../theme/boxShadow'
import round from '../../theme/round'

export default ({ form: { resetForm } }) => (
  <div style={styles.container}>
    <button style={styles.button} onClick={() => resetForm()}>
      Reset
    </button>
  </div>
)

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px',
  },
  button: {
    backgroundColor: colors.green,
    color: colors.white,
    padding: '10px 30px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    borderRadius: round,
    boxShadow,
  },
}
